<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'

    import InvoicesComponent from './component.invoices.all.svelte'

    if(!isPermission($adminStore, 'UsersView.Invoices.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Facturas" subtitle="Facturas emitidas a todos los usuarios" />
    <InvoicesComponent />
</View>
